export default __webpack_public_path__ + "static/media/persevere_1.559afdba.jpg";